module.exports = __webpack_public_path__ + "img/crest_trans_330px_new.f8fa2fb8.png";